<template>
  <div>
    <div class="row pt-3">
      <div class="col-6 l-m-b-20">
        <h1>Movers</h1>
      </div>
      <div class="col-4 text-right" v-if="$_can('carriers.movers.invite')">
        <router-link to="/movers/pending" class="btn btn-secondary">Check pending invitations</router-link>
        <button class="btn btn-primary" @click="showInviteModal = true">
          INVITE MOVERS
        </button>
      </div>
      <div class="col-2 text-right"
           v-if="$_can('carriers.movers.store')"
      >
        <button class="btn btn-primary" @click="showCreateSidebar = !showCreateSidebar">
          ADD MOVER
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 l-m-b-20">
        <div class="input-group search">
          <button type="button" class="btn input-group-btn" @click="clearSearch">
            <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
          </button>
          <input class="form-control" type="text" v-model="q" @keyup="searchText($event)" placeholder="Search" />
        </div>
      </div>
      <div class="col-12 filters-field">
        <span>Filters:</span>
        <span v-if="filtersLoaded">
          <span v-if="filters.carrier.length && carriers">
            <span v-for="carrier in filters.carrier" :key="carrier" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('carrier', carriers)" />
              Carrier: {{ carriers.find(el => el.id === carrier).name }}</span>
          </span>
          <span v-if="filters.status" class="filter-item btn btn-filter">
            <span class="mod-icon-filter" @click="removeFilter('status')" />
            Status: {{ moverStatuses.find(el => el.id === filters.status).name }}</span>
          <span v-if="filters.foreman !== ''" class="filter-item btn btn-filter">
            <span class="mod-icon-filter" @click="removeFilter('foreman')" />
            Foreman: {{ filters.foreman === 1 ? 'Yes' : 'No' }}</span>
          <span v-if="filters.ssn !== ''" class="filter-item btn btn-filter">
            <span class="mod-icon-filter" @click="removeFilter('ssn')" />
            SSN Verified: {{ filters.ssn === 1 ? 'Yes' : 'No' }}</span>
          <span v-if="filters.inactive !== ''" class="filter-item btn btn-filter">
            <span class="mod-icon-filter" @click="removeFilter('inactive')" />
            Show Inactive: {{ filters.inactive === 1 ? 'Yes' : 'No' }}</span>
        </span>
        <button class="btn btn-secondary add-filters" @click="showFilters = true">
          <i class="fa fa-plus filter-icon" />
        </button>
      </div>
    </div>
    <template v-if="!movers">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <table class="table m-table table-hover l-m-t-20">
        <thead class="m-table__heading">
          <tr>
            <th class="m-table__id">ID</th>
            <th @click="sortBy('users.first_name')" :class="{ active: sortKey === 'users.first_name' }"
                class="sortable"
            >
              Name
              <span class="arrow" :class="sortOrders['users.first_name'] ? 'dsc' : 'asc'" />
            </th>
            <th @click="sortBy('users.email')" :class="{ active: sortKey === 'users.email' }" class="sortable">
              Email
              <span class="arrow" :class="sortOrders['users.email'] ? 'dsc' : 'asc'" />
            </th>
            <th>Phone</th>
            <th>Foreman</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="mover in movers" @mouseup="$_can('carriers.movers.show') && view($event, mover.id)" class="pointer"
              :key="mover.id"
          >
            <td>{{ mover.id }}</td>
            <td>
              <span>{{ mover.first_name }}</span>
              <span>{{ mover.last_name && mover.last_name }}</span>
            </td>
            <td>{{ mover.email }}</td>
            <td>{{ phoneMask.maskedPhone(mover.phone) }}</td>
            <td>{{ mover.foreman ? 'Yes' : 'No' }}</td>
            <td>{{ mover.status.name }}</td>
          </tr>
          <tr v-if="!movers.length">
            <td colspan="8" class="text-center">
              No results found
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="col-sm-6 mb-1 text-black-50"
             v-if="meta.total"
        >
          Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
        </div>
        <pagination class="col-sm-6 mb-1" :change-page="changePage" :meta="meta" />
      </div>
    </template>

    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div v-if="showFilters" class="filters-side-modal flex flex-column">
          <div @click="showFilters = !showFilters" class="pointer">
            <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
          </div>
          <div>
            <p>
              Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.
            </p>
          </div>
          <div class="l-bg-white">
            <div class="row">
              <div class="col">
                <div class="row filters">
                  <div class="col-12" v-if="carriers && carriers.length">
                    <div class="select-wrap">
                      <label>Carriers</label>
                      <key-multiselect v-model="filters.carrier"
                                       :options="carriers"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :close-on-select="false"
                                       :hide-selected="true"
                                       :id="'carrier-select'"
                                       :placeholder="'Select Carriers'"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Status</label>
                      <simple-select v-model="filters.status"
                                     :options="moverStatuses"
                                     :input-id="'status-select'"
                                     placeholder="Select Status"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Foreman</label>
                      <simple-select v-model="filters.foreman"
                                     :options="booleanOptions"
                                     :input-id="'foreman-select'"
                                     placeholder="Foreman"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>SSN</label>
                      <simple-select v-model="filters.ssn"
                                     :options="booleanOptions"
                                     :input-id="'ssn-verified-select'"
                                     placeholder="SSN Verified"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Show inactive</label>
                      <simple-select v-model="filters.inactive"
                                     :options="booleanOptions"
                                     :input-id="'inactive-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                      v-if="!clearFiltersButtonShouldBeDisabled"
              >
                Clear filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <modal v-if="showInviteModal" @close="closeModal" :size="'modal-large'">
      <template v-if="showInviteModalMode === 'separate'">
        <div slot="header">
          <div class="row">
            <div class="col-12">
              <div>
                <h4 class="mb-3">Invite movers to mod24 for your carrier</h4>
                <div class="select-wrap">
                  <label>Select Carrier</label>
                  <simple-select v-model="dataToSend.carrier_id"
                                 :options="carriers"
                                 label="name"
                                 @change="clearError($event)"
                  />
                </div>
                <error-field :errors="errors" field="carrier_id" />
              </div>
            </div>
          </div>
        </div>
        <div slot="body">
          <h5>Email addresses</h5>
          <form @submit.prevent="sendInvitations" autocomplete="off">
            <div v-for="(email, index) in dataToSend.emails"
                 :key="`em-${index}`"
            >
              <div class="row mb-2">
                <div class="col-11">
                  <div class="select-wrap">
                    <label>Enter email</label>
                    <input type="email"
                           autocomplete="false"
                           class="form-control"
                           placeholder="email@example.com"
                           v-model="dataToSend.emails[index]"
                           @keydown="clearError($event)"
                    />
                  </div>
                </div>
                <div class="col-1 pt-3">
                  <div class="btn btn-clear"
                       v-if="index > 0 || dataToSend.emails.length !== 1"
                       @click="removeField(index)"
                  >
                    <i class="fa fa-remove" />
                  </div>
                </div>
              </div>
              <error-field :errors="errors" :field="`emails.${index}`" />
            </div>
          </form>
          <error-field :errors="errors" field="emails" />
          <span @click="addField" class="btn add-button mr-2"><span><i aria-hidden="true"
                                                                       class="fa fa-plus"
          /></span>Add one more</span>
          or
          <span @click="showInviteModalMode = 'bulk'" class="btn add-button ml-2"><span><i aria-hidden="true"
                                                                                           class="fa fa-plus"
          /></span> Add many at once</span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-12 text-right">
              <button type="button" class="btn btn-primary ld-ext-right"
                      @click="sendInvitations"
                      :class="loadingButton ? 'running' : ''"
                      :disabled="buttonDisabled"
              >
                Send invitations
                <div class="ld ld-ball ld-flip" />
              </button>
            </div>
          </div>
        </div>
      </template>

      <template v-if="showInviteModalMode === 'bulk'">
        <div slot="header">
          <div class="row">
            <div class="col-12">
              <div>
                <h4 class="mb-3">Invite movers to mod24 for your carrier:</h4>
                <div class="select-wrap">
                  <label>Select Carrier</label>
                  <simple-select v-model="dataToSend.carrier_id"
                                 :options="carriers"
                                 label="name"
                                 @change="clearError($event)"
                  />
                </div>
                <error-field :errors="errors" field="carrier_id" />
              </div>
            </div>
          </div>
        </div>
        <div slot="body">
          <h5>Enter multiple email addresses</h5>
          <div class="row">
            <div class="col-12">
              <div class="select-wrap select-wrap-textarea">
                <label>Enter email addresses</label>
                <textarea cols="30" rows="10" class="form-control select-wrap-textarea" placeholder=""
                          v-model="emailsBulk"
                          @keydown="clearError($event)"
                />
              </div>
              <error-field :errors="errors" field="emails" />
              Please use commas to separate email addresses entered. You can always
              <span @click="showInviteModalMode = 'separate'" class="btn add-button">go back</span> to adding single
              addresses.
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-12 text-right">
              <button type="button" class="btn btn-primary ld-ext-right"
                      :class="loadingButton ? 'running' : ''"
                      :disabled="buttonDisabled"
                      @click="sendInvitations"
              >
                Send invitations
                <div class="ld ld-ball ld-flip" />
              </button>
            </div>
          </div>
        </div>
      </template>
      <div />
    </modal>
    <!-- Create User -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showCreateSidebar" @click.self="showCreateSidebar = false">
        <movers-create class="sidebar-right" @cancel="showCreateSidebar = false"
                       @update="updateAfterCreating"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import toastr from 'toastr';
import Modal from '../Modal';
import MoversCreate from './MoversCreate';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import Pagination from '../Pagination';
import PhoneMask from '../../classes/PhoneMask';

export default {
  name: 'Movers',
  components: {
    ErrorField,
    Modal,
    MoversCreate,
    Pagination,
  },
  data() {
    return {
      filters: {
        carrier: [],
        status: '',
        foreman: '',
        ssn: '',
        inactive: '',
      },
      sortKey: '',
      sortOrders: [],
      page: 1,
      showCreateSidebar: false,
      showInviteModal: false,
      showInviteModalMode: 'separate',
      emailsBulk: '',
      dataToSend: {
        carrier_id: null,
        emails: [''],
      },
      emailsResend: [],
      invited: [],
      q: '',
      booleanOptions: [
        {
          id: 1,
          name: 'Yes',
        },
        {
          id: 0,
          name: 'No',
        },
      ],
      loadingButton: false,
      buttonDisabled: false,
      showFilters: false,
      phoneMask: new PhoneMask(),
      errors: new Errors(),
    };
  },
  computed: {
    ...mapState({
      movers: state => state.movers.paginatedMovers.data,
      meta: state => state.movers.paginatedMovers.meta,
      carriers: state => state.carriers.carriers.data,
      moverStatuses: state => state.values.moverStatuses,
      roles: state => state.values.roles,
      filtersSaved: state => state.filters.filtersSaved,
      filtersLoaded: state => state.guard.filtersLoaded,
    }),
    ...mapGetters(['getMoversFiltered', 'getFiltersSaved']),
    clearFiltersButtonShouldBeDisabled() {
      return (
        !this.filters.carrier.length &&
        !this.filters.status &&
        !this.filters.foreman &&
        this.filters.foreman !== 0 &&
        !this.filters.ssn &&
        this.filters.ssn !== 0 &&
        !this.filters.inactive &&
        this.filters.inactive !== 0
      );
    },
  },
  mounted() {
    this.getMoverStatuses();
    if (this.filtersSaved && this.filtersSaved.previousPage === 'MoversEdit') {
      this.filters = { ...this.filtersSaved };
      this.page = this.filtersSaved.page;
      this.filter();
    } else {
      if (Object.keys(this.$route.query).length !== 0) {
        this.setFilters(this.$route.query);
      }
      this.filter();
    }
  },
  methods: {
    ...mapActions(['getMoverStatuses']),
    ...mapMutations(['setPaginatedMovers', 'setFiltersSaved']),
    setFilters(query) {
      this.filters = Object.assign(
        {
          carrier: query.carrier_id ? query.carrier_id.split(',').map(i => Number(i)) : [],
          status: query.status_id ? parseInt(query.status_id, 10) : '',
          foreman: query.foreman ? parseInt(query.foreman, 10) : '',
          ssn: query.ssn_verified ? parseInt(query.ssn_verified, 10) : '',
          inactive: query.inactive ? parseInt(query.inactive, 10) : '',
        },
        {},
      );
      this.sortKey = query.sort;
      this.sortOrders = query.order;
      this.page = query.page;
      this.q = query.q.toString();
    },
    view(event, id) {
      if (event.button === 1) {
        window.open(this.$router.resolve(`/movers/edit/${id}`).href, '_blank');
      } else {
        this.$router.push(`/movers/edit/${id}`);
      }
    },
    closeModal() {
      this.showInviteModal = false;
      this.showInviteModalMode = 'separate';
      this.dataToSend = {
        carrier_id: null,
        emails: [''],
      };
      this.emailsBulk = '';
      this.errors.clear();
    },
    updateAfterCreating() {
      this.filter();
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    addField() {
      this.dataToSend.emails.push('');
    },
    removeField(index) {
      this.dataToSend.emails.splice(index, 1);
    },
    sendInvitations() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      if (this.showInviteModalMode === 'bulk') {
        this.dataToSend.emails = this.emailsBulk
          .trim()
          .replace(/(^,)|(,$)/g, '')
          .split(',');
        this.sendInvitationsPost({ ...this.dataToSend });
      } else {
        this.sendInvitationsPost({ ...this.dataToSend });
      }
    },
    sendInvitationsPost(data) {
      axios
        .post(`movers/invite`, { ...data })
        .then(() => {
          toastr.success('Successfully sent invitations');
          this.dataToSend = {
            carrier_id: null,
            emails: [''],
          };
          this.emailsResend = [];
          this.emailsBulk = '';
          this.showInviteModal = false;
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    changePage(pageNum) {
      this.setPaginatedMovers({});
      this.page = pageNum;
      this.filter();
    },
    searchText(e) {
      this.page = 1;
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.filter();
        }, 500);
      }
    },
    search() {
      this.page = 1;
      this.filter();
    },
    filter() {
      const query =
        `page=${this.page}&carrier_id=${this.filters.carrier}&status_id=${this.filters.status}` +
        `&foreman=${this.filters.foreman}&ssn_verified=${this.filters.ssn}&inactive=${
          this.filters.inactive
        }&q=${encodeURIComponent(this.q)}&sort=${this.sortKey}&order=${
          this.sortOrders[this.sortKey] ? 'asc' : 'desc'
        }`;
      this.getMoversFiltered(query);
      if (this.$_checkProperties(this.filters)) {
        this.$router.push(`/movers?${query}`);
      } else {
        this.$router.push(`/movers`);
      }
    },
    clearFilters() {
      this.filters = Object.assign(
        {
          carrier: [],
          status: '',
          foreman: '',
          ssn: '',
          inactive: '',
        },
        {},
      );
      this.sortKey = '';
      this.sortOrders = [];
      this.filter();
      this.showFilters = false;
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
    sortBy(key) {
      this.sortKey = key;
      this.$set(this.sortOrders, key, !this.sortOrders[key]);
      this.filter();
    },
    removeFilter(model, id) {
      if (id) {
        this.filters[model] = this.filters[model].filter(element => element !== id);
      } else {
        this.filters[model] = '';
      }
      this.search();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/movers/Movers.vue